import {Component, Inject, OnInit} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';

@AcDialog({
  height: 100
})
@Component({
  selector: 'users-export-dialog',
  templateUrl: './users-export-dialog.component.html',
  styleUrls: ['./users-export-dialog.component.scss']
})
export class UsersExportDialogComponent implements OnInit {

  data;

  message = `Press OK to start exporting the list of users and their attributes `;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.data = dialogConfig.dialogData;
  }

  ngOnInit(): void {
  }

}
